var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"head-variant":"dark","fields":_vm.fields,"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }